/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React from "react";
import {
  AggregatedText,
  Date,
  DisplayInnerCards,
  InnerCards,
  InnerCardsText,
  InnerCardsTextNumber,
  NationalLevelLabel,
} from "../../HomeStyles";
import MoneyVector from "../../../../assets/Vector/MoneyVector.svg";
import UsergroupVector from "../../../../assets/Vector/UsergroupVector.svg";

function AggregatedCard({
  dateColor,
  AggTextColor,
  innerCardsColor,
  date,
  contributionAmount,
  contributions,
  structureName,
}) {
  return (
    <>
      <Date bgColor={dateColor}>{date}</Date>
      <AggregatedText color={AggTextColor}>
        Aggregated Contribution Amount and Receipt
      </AggregatedText>
      <DisplayInnerCards>
        <InnerCards bgColor={innerCardsColor}>
          <img
            src={MoneyVector}
            alt="/moneyvector"
            style={{ paddingTop: "10px" }}
          />
          <InnerCardsText>Aggregated Contribution</InnerCardsText>
          <InnerCardsTextNumber
            title={`₹ ${contributionAmount?.toLocaleString("en-IN")}`}
          >
            ₹ {contributionAmount?.toLocaleString("en-IN")}
          </InnerCardsTextNumber>
        </InnerCards>
        <InnerCards bgColor={innerCardsColor}>
          <img
            src={UsergroupVector}
            alt="/usergroupvector"
            style={{ paddingTop: "10px" }}
          />
          <InnerCardsText>Contribution Receipt</InnerCardsText>
          <InnerCardsTextNumber title={contributions?.toLocaleString("en-IN")}>
            {contributions?.toLocaleString("en-IN")}
          </InnerCardsTextNumber>
        </InnerCards>
      </DisplayInnerCards>
    </>
  );
}

export default AggregatedCard;
